import { render, staticRenderFns } from "./headerMessageLogin.vue?vue&type=template&id=f45500c8"
import script from "./headerMessageLogin.vue?vue&type=script&lang=js"
export * from "./headerMessageLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports